import React, { useContext, useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import LogContext from '../context/LogContext';
import { homeScroll } from '../smoothScroll';
import slugify from '../utils/slugify';
const backendUrl = process.env.REACT_APP_BACKEND_URL;
const adminUrl = process.env.REACT_APP_ADMIN_BACKEND_URL;

function NewArrivals() {
  const myContext = useContext(LogContext)
  const [data, setData] = useState([]);
  const [cart, setCart] = useState([])
  const navigate = useNavigate();
  const products = async () => {
    try {
      const response = await fetch(`${backendUrl}/new`, {
        method: 'POST',
        headers: {
          "content-type": "application/json"
        }
      });
      if (response.ok) {
        const responseData = await response.json();
        setData(responseData["data"].slice(0, 4));
      }
      else {
        console.log("Can't get the newArrival data")
      }
    } catch (error) {
      console.log("Error getting newArrivals", error);
    }

  };
  const cartUpdate = async () => {
    try {
      const response = await fetch(`${backendUrl}/cartData`, {
        method: "POST",
        headers: {
          "content-type": "application/json"
        },
        body: JSON.stringify({ email: myContext.user.email })
      });

      if (response.ok) {
        const productArray = await response.json();
        setCart(productArray.cartItems);
      } else {
        // If the response status is not OK, log the status and possibly the response body
        console.log("error occured in getting cart data")
      }
    } catch (error) {
      // If an exception occurs during the fetch or parsing the response, log the error
      console.error("Error fetching cart data:");
    }
  }
  const addToCartHandler = async (itemID) => {
    try {
      if (!myContext.user.email) {
        navigate('/login');
      }
      else if (cart.filter(items => items.productID === itemID).length != 0) {
        console.log("already In cart");
      }
      else {
        const response = await fetch(`${backendUrl}/cartHandler`, {
          method: "POST",
          headers: {
            "content-type": "application/json"
          },
          body: JSON.stringify({ "email": myContext.user.email, "itemID": itemID })
        });
        if (response.ok) {
          myContext.updateCart(itemID);
          console.log("info send successfully");
          // window.location.reload();

        }
        else {
          console.log("info not send successfully")
        }

      }
    } catch (error) {
      console.log("Some error occured", error)
    }

  };
  const whishlistHandler = async (productID) => {
    const response = await fetch(`${backendUrl}/addToWishlist`, {
      method: 'POST',
      headers: {
        "content-type": "application/json"
      },
      body: JSON.stringify({ email: myContext.user.email, productID })
    });
    try {
      if (response.ok) {
        console.log("added to wishlist");
      }
      else {
        console.log("problem sending data")
      }
    }
    catch (error) {
      console.log("error Occured", error)
    }
  }
  useEffect(() => {
    products();
  }, []);

  return (
    <section id="new-arrivals" className="new-arrivals" style={{paddingTop:'0'}}>
      <div className="container">
        <div className="section-header">
          <h2>new arrivals</h2>
        </div>
        <div className="new-arrivals-content">
          <div className="row">
            {
              data &&
              data.map((item, index) => (
                <div key={index} className="col-md-3 col-sm-4 col-xs-6">
                  <div className="single-new-arrival">
                    <div className="single-new-arrival-bg">
                      <img src={`${adminUrl}/uploads/products/${item.images[0].preview}`} alt="new-arrivals images" style={{ height: '310px', width: '100%' }} />
                      <div className="single-new-arrival-bg-overlay"></div>
                      <div className="sale bg-1">
                        <p>sale</p>
                      </div>
                      <div className="new-arrival-cart">
                        <p>
                          <span className="lnr lnr-cart"></span>
                          <button onClick={(e) => { addToCartHandler(item._id) }}>add <span>to </span> cart</button>
                        </p>
                        <p className="arrival-review pull-right">
                          <span className="lnr lnr-heart" style={{ cursor: 'pointer' }} onClick={() => { whishlistHandler(item._id) }} ></span>
                          <span className="lnr lnr-frame-expand"></span>
                        </p>
                      </div>
                    </div>
                    <h4><Link to={`/products/${item.title}`} onClick={(e) => { homeScroll('forProduct'); localStorage.setItem('currentProduct', item.title); myContext.updateProduct(`${item.title}`) }}>{item.title}</Link></h4>
                    <p className="arrival-product-price"><span style={{ fontWeight: '500' }}>&#8377; {item.pricing.offerPrice} </span><span style={{ fontSize: '12px' }}>M.R.P <del>&#8377; {item.pricing.MRP}</del></span></p>
                  </div>
                </div>
              ))
            }
          </div>
        </div>
      </div>
    </section>
  );
}

export default NewArrivals;
